import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { CardDownload, CardPersonaOrgParams, CardIdParams } from '../models/download'

@Component({
  standalone: false,
  selector: 'app-card-download',
  template: '',
  styles: []
})
export class CardDownloadComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  public ngOnInit(): void {
    const pathParams = this.route.snapshot.params
    const queryParams = this.route.snapshot.queryParams
    let downloadParams

    if (pathParams.id) {
      downloadParams = new CardIdParams(pathParams.id, queryParams.device_type)
    } else if (queryParams.persona_id && queryParams.boss_organization_id) {
      downloadParams = new CardPersonaOrgParams(queryParams)
    } else {
      return
    }

    new CardDownload(downloadParams).download()
  }
}
